import React from 'react';
import { UserEntityBadgeContainer, StyledBadgeText } from './styled.js';

const UserEntityBadge = ({ position }) => (
  <UserEntityBadgeContainer position={position}>
    <StyledBadgeText>You</StyledBadgeText>
  </UserEntityBadgeContainer>
);

export default UserEntityBadge;
